import type { Rule } from '@/types/strategy'

interface RuleSectionProps {
  title: string
  rules: Rule[]
  /**
   * Mapping vom JSON-Config-Key auf einen Anzeige-Label-String.
   * Pro Kategorie gibt's andere relevante Felder, daher konfigurierbar.
   */
  fieldLabels?: Record<string, string>
  /**
   * Felder, die in der Config existieren aber nicht im Grid angezeigt werden
   * sollen (z. B. interne Marker).
   */
  hideKeys?: string[]
}

function formatValue(value: unknown): string {
  if (value === null || value === undefined) return '—'
  if (typeof value === 'boolean') return value ? 'ja' : 'nein'
  if (Array.isArray(value)) return value.join(', ')
  if (typeof value === 'object') return JSON.stringify(value)
  return String(value)
}

export function RuleSection({ title, rules, fieldLabels = {}, hideKeys = [] }: RuleSectionProps) {
  if (rules.length === 0) return null

  return (
    <section>
      <h3 className="tracked-caps mb-3 text-[10px] text-bernstein">{title}</h3>
      <div className="flex flex-col">
        {rules.map((rule) => {
          const visibleEntries = Object.entries(rule.config).filter(
            ([key]) => !hideKeys.includes(key),
          )
          return (
            <article key={rule.id} className="hairline-b py-3">
              <header className="flex items-baseline justify-between gap-3">
                <p className="text-sm text-ink">{rule.name}</p>
                {!rule.active && (
                  <span className="tracked-caps text-[10px] text-faint">inaktiv</span>
                )}
              </header>
              {visibleEntries.length > 0 && (
                <dl className="mt-1.5 grid grid-cols-1 gap-x-6 gap-y-1 font-mono text-[11px] text-muted md:grid-cols-2">
                  {visibleEntries.map(([key, value]) => (
                    <div key={key} className="flex justify-between gap-2">
                      <dt className="truncate">{fieldLabels[key] ?? key}</dt>
                      <dd className="truncate text-ink">{formatValue(value)}</dd>
                    </div>
                  ))}
                </dl>
              )}
            </article>
          )
        })}
      </div>
    </section>
  )
}
